// extracted by mini-css-extract-plugin
export default {"price-form":"PriceForm_price-form__7Qq0K","price-form__toolbar":"PriceForm_price-form__toolbar__1nCLs","price-form--edit":"PriceForm_price-form--edit__5Ju8g"};